import { api } from "../constants/apis";
import { get } from "./axios-requests";

export const getNameFromProfile = (profile) => {
    if (!profile)
        return '';

    let name = "";

    if (profile?.NamePrefix?.infoValue)
        name += profile.NamePrefix.infoValue + " ";

    if (profile?.FirstName?.infoValue)
        name += profile.FirstName.infoValue + " ";

    if (profile?.MiddleName?.infoValue)
        name += profile.MiddleName.infoValue + " ";

    if (profile?.LastName?.infoValue)
        name += profile.LastName.infoValue + " ";

    if (profile?.NameSuffix?.infoValue)
        name += profile.NameSuffix.infoValue + " ";

    if (profile?.Nickname?.infoValue && !profile.isBasic && name === '')
        name = profile.Nickname.infoValue;
    else if (profile?.Nickname?.infoValue && !profile.isBasic && name !== '' && (profile.JobTitle || profile.Field))
        name += '(' + profile.Nickname.infoValue + ')';


    return name ? name : "User " + profile?._id;
}


export const getNameFromProfileOptions = (profile, nameFormat, lang) => {
    if (!profile || Object.keys(profile).length === 0)
        return '';
    let name = "";
    let viewLang = lang;

    if (!viewLang || !Object.values(profile).some(k => k?.infoValue && k?.infoValue[viewLang])) {
        const validValue = Object.values(profile).find(value => value?.infoValue)?.infoValue;
        if (validValue) viewLang = Object.keys(validValue)[0];
    }

    if (nameFormat === 'Last First') {
        if (profile.NamePrefix?.infoValue[viewLang])
            name += profile.NamePrefix.infoValue[viewLang] + " ";

        if (profile.LastName?.infoValue[viewLang])
            name += profile.LastName.infoValue[viewLang];

        if (profile.FirstName?.infoValue[viewLang]) {
            if (profile.LastName)
                name += ", "
            name += profile.FirstName.infoValue[viewLang];
        }

        if (profile.MiddleName?.infoValue[viewLang])
            name += " " + profile.MiddleName.infoValue[viewLang];

        if (profile.NameSuffix?.infoValue[viewLang])
            name += " " + profile.NameSuffix.infoValue[viewLang];

        if (!profile.isBasic && profile.Nickname && name !== '' && (profile.JobTitle || profile.Field))
            name += " (" + profile.Nickname.infoValue[viewLang] + ")";

        if (!profile.isBasic && profile.Nickname && name === '')
            name = profile.Nickname.infoValue[viewLang];

    } else {
        if (profile.NamePrefix?.infoValue[viewLang])
            name += profile.NamePrefix.infoValue[viewLang] + " ";

        if (profile.FirstName?.infoValue[viewLang])
            name += profile.FirstName.infoValue[viewLang];

        if (profile.MiddleName?.infoValue[viewLang])
            name += " " + profile.MiddleName.infoValue[viewLang];

        if (profile.LastName?.infoValue[viewLang])
            name += " " + profile.LastName.infoValue[viewLang];

        if (profile.NameSuffix?.infoValue[viewLang])
            name += " " + profile.NameSuffix.infoValue[viewLang];

        if (!profile.isBasic && profile.Nickname && name !== '' && (profile.JobTitle || profile.Field))
            name += " (" + profile.Nickname.infoValue[viewLang] + ")";

        if (!profile.isBasic && profile.Nickname && name === '')
            name = profile.Nickname.infoValue[viewLang];
    }

    return name ? name : "User " + profile._id.toString().substring(5, 10);
}

export const nFormatter = function (num, digits) {
    var si = [
        { value: 1, symbol: "" },
        { value: 1E3, symbol: "k" },
        { value: 1E6, symbol: "M" },
        { value: 1E9, symbol: "G" },
        { value: 1E12, symbol: "T" },
        { value: 1E15, symbol: "P" },
        { value: 1E18, symbol: "E" }
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;
    for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
            break;
        }
    }
    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}

export const getPhoneNumberWihKey = function (numberInfo) {
    if (!numberInfo)
        return '';
    const number = numberInfo?.countryCode + numberInfo?.infoValue
    return number[0] === '+' ? number : '+' + number;
}


export const getShareLink = async function (cardId) {
    const res = await get(api.cards.shareLink, { cardId });
    return res.data;
}